<template>
  <router-link tag="div" class="menu-user" :to="{name:'dashboard',query: {student: user.id}}">
    <b-list-group-item class="d-flex align-items-center list-groupelt">
      <b-avatar variant="info" :src="user.avatar" class="mr-3" style="width: 50px; height: 50px"></b-avatar>
      <div class="mr-2 flex-grow">
        <div>{{ user.full_name }}</div>
        <div class="coloredText">{{ user.classroom && user.classroom.name }}</div>
      </div>
      <span class="onlineState">
        <b-icon-circle-fill v-if="user.online" style="color: #00aaa5; height:10px"></b-icon-circle-fill>
        <b-icon-circle v-else style="height:10px"></b-icon-circle>
      </span>
    </b-list-group-item>
  </router-link>
</template>

<script>
export default {
  name: 'MenuUser',
  props: {
    user: {required: true},
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.menu-user {
  cursor: pointer;

  &:hover {
    background: #ccc;
  }
}

.list-groupelt {
  padding: 3px 6px 3px 3px !important;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #ccc;
}

.coloredText {
  font-size: 11px;
  color: #00aaa5;
  margin-top: -2px;
}

</style>
